import React, { useState, useEffect } from 'react';
import TextInput from '../../layout/forms/TextInput';

const InternalTag = ({ state, setState }) => {
    const onChange = (event) => {
        setState({
            ...state,
            internalTag: event.target.value
        })
    }
    return (
        <TextInput
            label="Internal tag"
            onChange={onChange}
            value={state.internalTag}
        />
    )
}
export default InternalTag